module.exports = __webpack_public_path__ + "static/img/hero-bg.78c3e7f9.png";